import React, { useEffect, useState } from "react";
import PageTitle from "../../../jsx/layouts/PageTitle";

const initialForm = {
  category: "",
  title: "",
  slug: "",
  short_description: "",
  content: "",

  section1_title: "",
  section1: "",

  section2_title: "",
  section2: "",

  section3_title: "",
  section3: "",

  faq1_question: "",
  faq1_answer: "",

  faq2_question: "",
  faq2_answer: "",

  faq3_question: "",
  faq3_answer: "",
};

const categories = [
  "Vascular",
  "Interventional",
  // "General Surgery",
  // "ENT",
  "P Shot",
];

const ServicesDashboard = () => {
  const [services, setServices] = useState([]);
  const [form, setForm] = useState(initialForm);

  const [files, setFiles] = useState({
    banner_image: null,
    main_image: null,
  });

  const [editingId, setEditingId] = useState(null);

  const [openSections, setOpenSections] = useState({
    Vascular: true,
    Interventional: true,
    "General Surgery": true,
    ENT: true,
    "P Shot": true,
  });

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const res = await fetch("https://admin.drgargevascular.com/backend/services");
      const data = await res.json();

      if (Array.isArray(data)) {
        setServices(data);
      } else {
        console.error("Services API did not return array:", data);
        setServices([]);
      }
    } catch (error) {
      console.error("Error fetching services:", error);
      setServices([]);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "title") {
      const slug = value
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");

      setForm({ ...form, title: value, slug });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleFileChange = (e) => {
    setFiles({ ...files, [e.target.name]: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    Object.keys(form).forEach((key) => {
      formData.append(key, form[key]);
    });

    if (files.banner_image) formData.append("banner_image", files.banner_image);
    if (files.main_image) formData.append("main_image", files.main_image);

    try {
      const url = editingId
        ? `https://admin.drgargevascular.com/backend/services/${editingId}`
        : "https://admin.drgargevascular.com/backend/services";

      const method = editingId ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        body: formData,
      });

      const data = await res.json();
      console.log("Save response:", data);

      resetForm();
      fetchServices();
    } catch (error) {
      console.error("Error saving service:", error);
    }
  };

  const handleEdit = (service) => {
    setEditingId(service.id);

    setForm({
      category: service.category || "",
      title: service.title || "",
      slug: service.slug || "",
      short_description: service.short_description || "",
      content: service.content || "",

      section1_title: service.section1_title || "",
      section1: service.section1 || "",

      section2_title: service.section2_title || "",
      section2: service.section2 || "",

      section3_title: service.section3_title || "",
      section3: service.section3 || "",

      faq1_question: service.faq1_question || "",
      faq1_answer: service.faq1_answer || "",

      faq2_question: service.faq2_question || "",
      faq2_answer: service.faq2_answer || "",

      faq3_question: service.faq3_question || "",
      faq3_answer: service.faq3_answer || "",
    });

    setFiles({
      banner_image: null,
      main_image: null,
    });

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDelete = async (id) => {
    try {
      await fetch(`https://admin.drgargevascular.com/backend/services/${id}`, {
        method: "DELETE",
      });

      setServices((prev) => prev.filter((item) => item.id !== id));

      if (editingId === id) {
        resetForm();
      }
    } catch (error) {
      console.error("Error deleting service:", error);
    }
  };

  const resetForm = () => {
    setForm(initialForm);
    setFiles({
      banner_image: null,
      main_image: null,
    });
    setEditingId(null);
  };

  const toggleSection = (category) => {
    setOpenSections((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  const getServicesByCategory = (category) => {
    return services.filter((service) => service.category === category);
  };

  return (
    <>
      <PageTitle activeMenu="Services" motherMenu="Dashboard" />

      <div className="row">
        {/* ================= FORM ================= */}
        <div className="col-xl-12">
          <div className="card shadow-sm">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h4 className="mb-0">
                {editingId ? "Edit Service" : "Add Service"}
              </h4>

              {editingId && (
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  onClick={resetForm}
                >
                  Cancel Edit
                </button>
              )}
            </div>

            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Category</label>
                    <select
                      name="category"
                      className="form-control"
                      value={form.category}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Category</option>
                      <option value="Vascular">Vascular</option>
                      <option value="Interventional">Interventional</option>
                      {/* <option value="General Surgery">General Surgery</option> */}
                      {/* <option value="ENT">ENT</option> */}
                      <option value="P Shot">P Shot</option>
                    </select>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Service Title</label>
                    <input
                      type="text"
                      name="title"
                      className="form-control"
                      value={form.title}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Slug</label>
                    <input
                      type="text"
                      name="slug"
                      className="form-control"
                      value={form.slug}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-12 mb-3">
                    <label className="form-label fw-bold">Short Description</label>
                    <textarea
                      name="short_description"
                      className="form-control"
                      rows="3"
                      value={form.short_description}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Banner Image</label>
                    <input
                      type="file"
                      name="banner_image"
                      className="form-control"
                      onChange={handleFileChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Main Image</label>
                    <input
                      type="file"
                      name="main_image"
                      className="form-control"
                      onChange={handleFileChange}
                    />
                  </div>

                  {/* <div className="col-md-12 mb-3">
                    <label className="form-label fw-bold">Main Content</label>
                    <textarea
                      name="content"
                      className="form-control"
                      rows="5"
                      value={form.content}
                      onChange={handleChange}
                    ></textarea>
                  </div> */}

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Section 1 Title</label>
                    <input
                      type="text"
                      name="section1_title"
                      className="form-control"
                      value={form.section1_title}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Section 1 Content</label>
                    <textarea
                      name="section1"
                      className="form-control"
                      rows="4"
                      value={form.section1}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Section 2 Title</label>
                    <input
                      type="text"
                      name="section2_title"
                      className="form-control"
                      value={form.section2_title}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Section 2 Content</label>
                    <textarea
                      name="section2"
                      className="form-control"
                      rows="4"
                      value={form.section2}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Section 3 Title</label>
                    <input
                      type="text"
                      name="section3_title"
                      className="form-control"
                      value={form.section3_title}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Section 3 Content</label>
                    <textarea
                      name="section3"
                      className="form-control"
                      rows="4"
                      value={form.section3}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <div className="col-12 mt-3 mb-2">
                    <h5 className="border-bottom pb-2">FAQ Section</h5>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">FAQ 1 Question</label>
                    <input
                      type="text"
                      name="faq1_question"
                      className="form-control"
                      value={form.faq1_question}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">FAQ 1 Answer</label>
                    <textarea
                      name="faq1_answer"
                      className="form-control"
                      rows="2"
                      value={form.faq1_answer}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">FAQ 2 Question</label>
                    <input
                      type="text"
                      name="faq2_question"
                      className="form-control"
                      value={form.faq2_question}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">FAQ 2 Answer</label>
                    <textarea
                      name="faq2_answer"
                      className="form-control"
                      rows="2"
                      value={form.faq2_answer}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">FAQ 3 Question</label>
                    <input
                      type="text"
                      name="faq3_question"
                      className="form-control"
                      value={form.faq3_question}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">FAQ 3 Answer</label>
                    <textarea
                      name="faq3_answer"
                      className="form-control"
                      rows="2"
                      value={form.faq3_answer}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <div className="col-md-12 mt-2">
                    <button className="btn btn-primary me-2">
                      {editingId ? "Update Service" : "Add Service"}
                    </button>

                    {editingId && (
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={resetForm}
                      >
                        Cancel
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* ================= CATEGORY-WISE SERVICE LIST ================= */}
        <div className="col-xl-12">
          <div className="card shadow-sm">
            <div className="card-header">
              <h4 className="mb-0">All Services (Category Wise)</h4>
            </div>

            <div className="card-body">
              {categories.map((category) => {
                const categoryServices = getServicesByCategory(category);

                return (
                  <div key={category} className="mb-4 border rounded">
                    {/* CATEGORY HEADER */}
                    <div
                      className="d-flex justify-content-between align-items-center px-3 py-3"
                      style={{
                        background: "#f8f9fa",
                        cursor: "pointer",
                        borderBottom: openSections[category]
                          ? "1px solid #e9ecef"
                          : "none",
                      }}
                      onClick={() => toggleSection(category)}
                    >
                      <div>
                        <h5 className="mb-0 fw-bold">{category}</h5>
                        <small className="text-muted">
                          {categoryServices.length} service
                          {categoryServices.length !== 1 ? "s" : ""}
                        </small>
                      </div>

                      <button
                        type="button"
                        className={`btn btn-sm ${
                          openSections[category]
                            ? "btn-outline-danger"
                            : "btn-outline-primary"
                        }`}
                      >
                        {openSections[category] ? "Close" : "Open"}
                      </button>
                    </div>

                    {/* CATEGORY BODY */}
                    {openSections[category] && (
                      <div className="p-3">
                        {categoryServices.length > 0 ? (
                          categoryServices.map((service) => (
                            <div
                              key={service.id}
                              className="border rounded p-3 mb-3"
                              style={{ backgroundColor: "#fff" }}
                            >
                              <div className="row align-items-center">
                                {/* IMAGE */}
                                <div className="col-md-2 mb-3 mb-md-0">
                                  {service.main_image ? (
                                    <img
                                      src={`https://admin.drgargevascular.com/backend${service.main_image}`}
                                      alt={service.title}
                                      style={{
                                        width: "100%",
                                        height: "100px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                      }}
                                    />
                                  ) : (
                                    <div
                                      className="d-flex align-items-center justify-content-center border rounded"
                                      style={{
                                        width: "100%",
                                        height: "100px",
                                        fontSize: "12px",
                                        color: "#999",
                                      }}
                                    >
                                      No Image
                                    </div>
                                  )}
                                </div>

                                {/* DETAILS */}
                                <div className="col-md-7">
                                  <h5 className="mb-1">{service.title}</h5>

                                  <p
                                    className="mb-1"
                                    style={{
                                      fontSize: "13px",
                                      color: "#666",
                                    }}
                                  >
                                    {service.short_description
                                      ? service.short_description.substring(
                                          0,
                                          140
                                        ) + "..."
                                      : "No short description available"}
                                  </p>

                                  <p
                                    className="mb-0"
                                    style={{
                                      fontSize: "12px",
                                      color: "#999",
                                    }}
                                  >
                                    Slug: /service/{service.slug}
                                  </p>
                                </div>

                                {/* ACTIONS */}
                                <div className="col-md-3 text-md-end mt-3 mt-md-0">
  <div className="d-flex justify-content-md-end justify-content-start gap-2 flex-wrap">
    <button
      type="button"
      onClick={() => handleEdit(service)}
      className="btn btn-warning btn-sm px-3"
      style={{
        minWidth: "80px",
        height: "36px",
      }}
    >
      Edit
    </button>

    <button
      type="button"
      onClick={() => handleDelete(service.id)}
      className="btn btn-danger btn-sm px-3"
      style={{
        minWidth: "80px",
        height: "36px",
      }}
    >
      Delete
    </button>
  </div>
</div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="text-muted text-center py-3">
                            No services available under <b>{category}</b>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServicesDashboard;